function separateCardNumber (input) {
  return input?.match(/.{1,4}/g).join(' ') || ''
}

export {
  separateCardNumber
}
